import type { FilaConcentracion } from '@leadsphere/types';

import { fmtMXN, fmtPct } from '../../lib/moneda.js';

export function TablaConcentracion({ filas }: { filas: FilaConcentracion[] }) {
  return (
    <div className="reportes-card">
      <div className="reportes-card-titulo">Concentración por cliente</div>
      {filas.length === 0 ? (
        <div className="reportes-vacio">Sin facturación en el periodo.</div>
      ) : (
        <div className="table-scroll">
          <table className="main-table">
            <thead>
              <tr><th>Cliente</th><th>Facturado</th><th>Cobrado</th><th>Por cobrar</th><th>% del total</th></tr>
            </thead>
            <tbody>
              {filas.map(f => (
                <tr key={f.cliente_id ?? 'resto'}>
                  <td>{f.cliente}</td>
                  <td>{fmtMXN(f.facturado)}</td>
                  <td>{fmtMXN(f.cobrado)}</td>
                  <td>{fmtMXN(f.por_cobrar)}</td>
                  <td>{fmtPct(f.pct_total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
